export type TBufferZone = 'critical' | 'high' | 'medium' | 'low' | 'otog';

const BufferZones: Record<string, TBufferZone> = {
  0: 'critical',
  1: 'high',
  2: 'medium',
  3: 'low',
  4: 'otog'
};

export const BufferZonesOptions = Object.keys(BufferZones).map((key: string) => {
  return { key, value: BufferZones[key] };
});

export default BufferZones;
